import { useEffect, useRef } from "react";
import { useRecoilState } from "recoil";
import moment from "moment";
import { myTimeActualDateState } from "my-time/states/actual-date";
import { myTimeActualMonthState } from "my-time/states/actual-month";
import { myTimeActualYearState } from "my-time/states/actual-year";
import useRecordingPeriod from "my-time/hooks/use-recording-period/use-recording-period";

export const useMyTimeActualDate = () => {
  const [year, setYear] = useRecoilState(myTimeActualYearState);
  const [month, setMonth] = useRecoilState(myTimeActualMonthState);
  const [date, setDate] = useRecoilState(myTimeActualDateState);
  const { data: recordingPeriodData } = useRecordingPeriod();

  const initialized = useRef(false);

  useEffect(() => {
    if (recordingPeriodData && !initialized.current) {
      const recordingMoment = moment(recordingPeriodData, "YYYY. MMMM", true);
      if (recordingMoment.isValid()) {
        setYear(recordingMoment.format("YYYY"));
        setMonth(recordingMoment.format("MM"));
        setDate(recordingMoment.toDate());
        initialized.current = true;
      }
    }
  }, [recordingPeriodData, setYear, setMonth, setDate]);

  const calculatedDate = moment(`${year}-${month}`, "YYYY-MM").toDate();
  const formattedDate = moment(calculatedDate).format("YYYY. MMMM");

  const handleDateChange = (newDate: string | Date) => {
    const newMoment = moment(newDate);
    setYear(newMoment.format("YYYY"));
    setMonth(newMoment.format("MM"));
    setDate(newMoment.toDate());
  };

  return { date, formattedDate, year, month, handleDateChange };
};

export default useMyTimeActualDate;
